import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProviderComponent } from './provider.component';
import { AuthGuard } from 'src/app/auth/auth.guard';

import { ProviderDashboardComponent } from './provider-dashboard/provider-dashboard.component';
import { ProviderParkComponent } from './provider-park/provider-park.component';
import { ProviderRequestsComponent } from './provider-requests/provider-requests.component';

import { ProviderApplyComponent } from './provider-apply/provider-apply.component';
import { DealerPublicComponent } from '../dealer/dealer-public/dealer-public.component';
import { DealerAppointmentsComponent } from '../dealer/dealer-appointments/dealer-appointments.component';
import { JobSearchComponent } from '../dealer/job-search/job-search.component';
import { DealerMyProvidersComponent } from '../dealer/dealer-myproviders/dealer-myproviders.component';
import { DealerContractsComponent } from '../dealer/dealer-contracts/dealer-contracts.component';
import { DealerMyOwnersComponent } from '../dealer/dealer-myowners/dealer-myowners.component';
import { DealerConversationsComponent } from '../dealer/dealer-conversations/dealer-conversations.component';
import { ProviderBuyComponent } from '../provider/provider-buy/provider-buy.component';
import { ProviderRentComponent } from '../provider/provider-rent/provider-rent.component';
import { DealerNotificationsComponent } from '../dealer/dealer-notifications/dealer-notifications.component';
import { DealerAccountComponent } from '../dealer/dealer-account/dealer-account.component';
import { PostNewCarComponent } from '../owner/post-new-car/post-new-car.component';
import { DealerBecomePartnerComponent } from '../dealer/dealer-become-partner/dealer-become-partner.component';
import { ProviderKeepComponent } from './provider-keep/provider-keep.component';
import { ProviderKeepOfferComponent } from './provider-keep-offer/provider-keep-offer.component';
import { ProviderRentOfferComponent } from './provider-rent-offer/provider-rent-offer.component';
import { ProviderBuyOfferComponent } from './provider-buy-offer/provider-buy-offer.component';
import { TransactionStage } from 'src/app/public/common/constants/common-basic-data';
import { DealerSearchComponent } from 'src/app/public/account/elements/dealer-search/dealer-search.component';


const routes: Routes = [
  {
    path: '', component: ProviderComponent,
    children: [
      { path: '', canActivate: [AuthGuard], component: DealerAccountComponent },

      { path: 'dashboard', component: ProviderDashboardComponent },

      { path: 'park', canActivate: [AuthGuard], component: ProviderParkComponent },
      { path: 'post-new-car', component: PostNewCarComponent },

      { path: 'buy-offer', canActivate: [AuthGuard], component: ProviderBuyOfferComponent  },
      { path: 'buy-ongoing', canActivate: [AuthGuard], component: ProviderBuyComponent, data: { transactionStages: [ TransactionStage.ONGOING ] }   },
      { path: 'buy-completed', canActivate: [AuthGuard], component: ProviderBuyComponent, data: { transactionStages: [ TransactionStage.COMPLETED ] }  },

      { path: 'rent-offer', canActivate: [AuthGuard], component: ProviderRentOfferComponent },
      { path: 'rent-bookings', canActivate: [AuthGuard], component: ProviderRentComponent, data: { transactionStages: [ TransactionStage.CONFIRMED ] }   },
      { path: 'rent-ongoing', canActivate: [AuthGuard], component: ProviderRentComponent, data: { transactionStages: [ TransactionStage.ONGOING ] }  },
      { path: 'rent-completed', canActivate: [AuthGuard], component: ProviderRentComponent, data: { transactionStages: [ TransactionStage.COMPLETED ] }   },

      { path: 'servicing-offer', canActivate: [AuthGuard], component: ProviderKeepOfferComponent },
      { path: 'servicing-bookings', canActivate: [AuthGuard], component: ProviderKeepComponent, data: { transactionStages: [ TransactionStage.CONFIRMED ] }   },
      { path: 'servicing-ongoing', canActivate: [AuthGuard], component: ProviderKeepComponent, data: { transactionStages: [ TransactionStage.ONGOING  ]}  },
      { path: 'servicing-completed', canActivate: [AuthGuard], component: ProviderKeepComponent, data: { transactionStages: [ TransactionStage.COMPLETED ] }   },

      //{ path: 'requests', canActivate: [AuthGuard], component: ProviderRequestsComponent },
      { path: 'notifications', canActivate: [AuthGuard], component: DealerNotificationsComponent },
      { path: 'appointments', canActivate: [AuthGuard], component: DealerAppointmentsComponent },
      { path: 'conversations', canActivate: [AuthGuard], component: DealerConversationsComponent },
      
      { path: 'become', canActivate: [AuthGuard], component: ProviderApplyComponent },

      { path: 'account', component: DealerAccountComponent },
      { path: 'account-settings', component: DealerAccountComponent },
      { path: 'become-partner', canActivate: [AuthGuard], component: DealerBecomePartnerComponent },

      { path: 'my-owners', component: DealerMyOwnersComponent },
      { path: 'contracts', canActivate: [AuthGuard], component: DealerContractsComponent },

      { path: 'public', component: DealerPublicComponent },

      { path: 'search', component: DealerSearchComponent },

      { path: 'job-search', component: JobSearchComponent },

      //{ path: 'become-partner', component: BecomePartnerComponent },
      

      //{ path: 'public', component: OwnerPublicComponent },

      //{ path: 'post-new-car', component: PostNewCarComponent },
      //{ path: 'become-partner', component: BecomePartnerComponent },

      //{ path: '', redirectTo: '/admin/home', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProviderRoutingModule { }
